import { render, staticRenderFns } from "./OrderableItemFixtures.vue?vue&type=template&id=7ff4ba53&"
import script from "./OrderableItemFixtures.vue?vue&type=script&lang=ts&"
export * from "./OrderableItemFixtures.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports